
import dict from '@/config';
export default {
  computed: {
    getBgStyle() {
      return function (thumbnail_url) {
        return {
          background: `url(${thumbnail_url}) no-repeat center center`,
          'background-size': 'cover'
        }
      }
    },
    getContinerStyle() {
      let styleObj = {
        width: this.pageViewList.length * 375 + 'px',
        transform: `translate3d(-${(this.curPage - 1) * 375}px, 0, 0)`
      }
      return styleObj
    },
    getPageStyle() {
      return function (pageView) {
        const { width, height, background_image } = pageView
        const _height = document.querySelector('.album-content').offsetHeight
        const _ratio = (_height - 100) / height
        return {
          position: 'relative',
          width: `${width * _ratio}px`,
          height: `${height * _ratio}px`,
          backgroundColor: '#f0f2f5',
          backgroundImage: `url(${background_image.url})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover'
        }
      }
    },
    getFieldStyle() {
      return function (pageView, fieldView) {
        const _height = document.querySelector('.album-content').offsetHeight
        const _ratio = (_height - 100) / pageView.height
        const { width, height, top, left, type, default_style, default_value, default_image } = fieldView
        const { alignment, font_color, font_size, font_weight, line_height, rotate, border_color, border_radius, border_with } = default_style
        let styleObj = {
          position: 'absolute',
          top: `${top * _ratio}px`,
          left: `${left * _ratio}px`,
          width: `${width * _ratio}px`,
          height: `${height * _ratio}px`,
          color: '#999999',
          overflow: 'hidden',
          textAlign: 'justify',
          transform: `rotate(${rotate || 0}deg)`,
          wordBreak: 'break-all',
          whiteSpace: 'pre-wrap'
        }
        if (type === 'text') {
          styleObj = {
            ...styleObj,
            fontSize: `${font_size * _ratio}px`,
            lineHeight: line_height,
            font_weight
          }

          if (default_value && default_value.length) {
            styleObj.color = font_color ? `#${font_color.toString(16).slice(2)}` : '#515151'
          }

          styleObj.display = "flex";
          styleObj.flexFlow = "wrap row";
          if (alignment.startsWith("center")) {
            styleObj.alignItems = "center";
          } else if (alignment.startsWith("top")) {
            styleObj.alignItems = "flex-start";
          } else if (alignment.endsWith("bottom")) {
            styleObj.alignItems = "flex-end";
          }

          if (alignment.endsWith("center")) {
            styleObj.justifyContent = "center";
          } else if (alignment.endsWith("Right")) {
            styleObj.justifyContent = "flex-end";
          } else if (alignment.endsWith("Left")) {
            styleObj.justifyContent = "flex-start";
          }

          return styleObj
        }
        if (default_image) {
          Object.assign(styleObj, {
            backgroundImage: `url(${default_image.compressed_url})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'cover'
          })
        } else {
          styleObj.textAlign = 'center'
          styleObj.lineHeight = `${height * _ratio}px`
        }

        if (border_with) {
          default_style.border = `${border_with}px solid #${border_color.toString(16)}`
        }

        if (border_radius) {
          styleObj.borderRadius = `${border_radius * _ratio}px`
        }
        return styleObj
      }
    },

    getFieldValue() {
      return function (fieldView) {
        const { type, default_value, default_image, placeholder } = fieldView
        if (type === 'image') {
          return default_image ? '' : placeholder || '请点击选择图片'
        }
        if (default_value && default_value.trim().length) {
          return default_value
        }
        return placeholder || '请点击输入文字'
      }
    },

    canSubmitStatus() {
      const statusArr = Object.keys(dict.ALBUM_STATUS)
      return statusArr.includes(this.albumInfo.status)
    }
  },

  methods: {
    getAlbumTempBody(pageViews) {
      const pageViewList = [];
      pageViews.forEach((pageView) => {
        pageViewList.push(this.getAlbumTempPage(pageView));
      });

      return pageViewList;
    },
    getAlbumTempPage(pageView, isCopy = false) {
      const { background_image, section_views, ...others } = JSON.parse(JSON.stringify(pageView));
      for (let i = 0; i < section_views.length; i++) {
        section_views[i].field_views.map(item => {

          if (isCopy) {
            item.default_value = null;
            item.default_image_id = null;
          } else if (item.default_image) {
            item.default_image_id = item.default_image.id
          }

          delete item.default_image
        })
        section_views[i].fields = section_views[i].field_views
        delete section_views[i].field_views
      }

      return { background_image_id: background_image.id, sections: section_views, ...others }
    }
  },
}